/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface IBreadcrumb {
  text: string;
  link: string;
}

interface IAppState {
  isMobile: boolean;
  isTablet: boolean;
  isMobileMenuOpened: boolean;
  mobileBreadcrumbs: IBreadcrumb[];
  isChatRendered: boolean;
  isChatOpen: boolean;
  isChatOnline: boolean;
}

const initialState = {
  isMobile: false,
  isTablet: false,
  isMobileMenuOpened: false,
  mobileBreadcrumbs: [],
  isChatRendered: false,
  isChatOpen: false,
  isChatOnline: false,
} as IAppState;

const modalsSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setTablet(state, action: PayloadAction<boolean>) {
      state.isTablet = action.payload;
    },
    toggleMobileMenu(state, action: PayloadAction<boolean>) {
      state.isMobileMenuOpened = action.payload;
    },
    setMobileBreadcrumbs(state, action: PayloadAction<IBreadcrumb[]>) {
      state.mobileBreadcrumbs = action.payload;
    },
    setChatRendered(state, action: PayloadAction<boolean>) {
      state.isChatRendered = action.payload;
    },
    setChatOpen(state, action: PayloadAction<boolean>) {
      state.isChatOpen = action.payload;
    },
    setChatOnline(state, action: PayloadAction<boolean>) {
      state.isChatOnline = action.payload;
    },
  },
});

export const {
  setMobile,
  setTablet,
  toggleMobileMenu,
  setMobileBreadcrumbs,
  setChatRendered,
  setChatOpen,
  setChatOnline,
} = modalsSlice.actions;

export default modalsSlice.reducer;
